import React from 'react';
import styled from 'styled-components';
import * as Modals from 'styles/Modals';

const Title = styled.p`
  font-size: 22px;
  font-weight: bold;
  line-height: 19px;
  text-align: center;
  color: #ffffff;
  margin-bottom: 20px;
  margin-bottom: 20px;
`;

const Text = styled.p`
  font-size: 18px;
  line-height: 19px;
  text-align: center;
  color: #ffffff;
`;

const Circle = styled.div`
  display: inline-block;
  height: 165px;
  width: 165px;
  background: #ffffff;
  border-radius: 50%;
  margin-top: 60px;
  margin-bottom: 20px;
  text-align: center;
  position: relative;
`;

const ModalContent = styled.div`
  min-height: 400px;
  width: 494px;
  border-radius: 2px;
  background: #278c7e;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const ModalBody = styled.div`
  width: 280px;
  margin: 0 auto;
  text-align: center;
`;

const Icon = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 86px;
  line-height: 113px;
`;

type PropsType = {
  title: string,
  message: string,
  show: boolean,
  timerClose: number,
  autoClose: boolean,
  handleCloseModal: () => void,
  icon?: any
};

class ModalSuccessProcess extends React.Component<PropsType> {
  static defaultProps = {
    title: '¡Listo!',
    autoClose: false,
    show: false,
    timerClose: 5000,
    handleCloseModal: () => {}
  };

  constructor(props: PropsType) {
    super(props);
    this.timer = null;
  }

  closeModal = () => {
    this.timer = setTimeout(() => {
      clearTimeout(this.timer);
      this.props.handleCloseModal();
    }, this.props.timerClose);
  };

  renderIcon = () => {
    if (this.props.icon) return <Icon>{this.props.icon}</Icon>;
    else return <Icon>👍</Icon>;
  };

  render() {
    let { show, title, message, autoClose } = this.props;
    if (show) {
      if (autoClose) {
        this.closeModal();
      }
    }

    return (
      <Modals.ScreenOverlay show={show}>
        <ModalContent>
          <ModalBody>
            <Circle>{this.renderIcon()}</Circle>
            <Title>{title}</Title>
            <Text>{message}</Text>
          </ModalBody>
        </ModalContent>
      </Modals.ScreenOverlay>
    );
  }
}

export default ModalSuccessProcess;
